import { gql } from 'apollo-boost';

const manyQuery = gql`
  query statement($inputFilter: CertificationsAthleteFilterInputType) {
    statement(inputFilter: $inputFilter) {
      trainerId
      statusStatement
      certificationsId
      countAthletes
      athleteInExamCount
      trainer {
        id
        fullName
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteStatement($id: Int!, $certificationId: Int!) {
    deleteStatement(id: $id, certificationId: $certificationId) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const STATEMENT = {
  manyQuery,
  deleteMutation,
};

export default STATEMENT;
